import React from "react";
import "./RoomsSec2.css";

const RoomsSec2 = () => {
  return (
    <div>
      <div className="container-fluid room-1">
        <div className="rooms-our-room  pt-5">
          <span className="pr-1">OUR ROOMS</span>
          <img className="imgr-2" src="image434.webp" alt="hhh" />
        </div>
        <div className="row">
          <div className="col-1"></div>
          <div className="col-md-10">
            <img className="imgr-3" src="./r2.png" alt="hhh" />
          </div>
          <div className="col-1"></div>
        </div>
        <div className="row">
          <div className="col-3"></div>
          <div className="col-6 py-5">
            <p className="pr-2">Your Comfort is Our Priority</p>
          </div>
          <div className="col-3"></div>
        </div>
        <div className="row">
          <div className="col-1"></div>
          <div className="col-10">
            <p className="pr-3">
              At Surya vilas palace,we pride ourselves on providing an
              exceptional stay for every guest. Our range of luxurious and
              comfortable rooms is designed to cater to your every need, whether
              you're here for business or leisure. We understand that every
              guest is unique, and we go above and beyond to ensure your stay is
              memorable and enjoyable.
            </p>
          </div>
          <div className="col-1"></div>
        </div>
        <a href="/DeluxRoom">
          <div className="pr-4">View Full Details</div>
        </a>

        <div className="row py-4">
          <div className="col-1"></div>
          <div className="col-md-10">
            <img className="imgr-4" src="./r4.png" alt="hhh" />
          </div>
          <div className="col-1"></div>
        </div>
        <div className="row">
          <div className="col-3"></div>
          <div className="col-6 py-5">
            <p className="pr-2">Your Comfort is Our Priority</p>
          </div>
          <div className="col-3"></div>
        </div>
        <div className="row">
          <div className="col-1"></div>
          <div className="col-10">
            <p className="pr-3">
              At Surya vilas palace , we pride ourselves on providing an
              exceptional stay for every guest. Our range of luxurious and
              comfortable rooms is designed to cater to your every need, whether
              you're here for business or leisure. We understand that every
              guest is unique, and we go above and beyond to ensure your stay is
              memorable and enjoyable.
            </p>
          </div>
          <div className="col-1"></div>
        </div>
        <a href="/SuiteRoom">
          <div className="pr-4">View Full Details</div>
        </a>
        <div className="col-12 py-2"></div>
      </div>
    </div>
  );
};

export default RoomsSec2;
